var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTablet = function SvgTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 64,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M56 9H24a7 7 0 0 0-7 7v48a7 7 0 0 0 7 7h32a7 7 0 0 0 7-7V16a7 7 0 0 0-7-7m5 55a5 5 0 0 1-5 5H24a5 5 0 0 1-5-5V16a5 5 0 0 1 5-5h32a5 5 0 0 1 5 5Z"
  })));
};
export default SvgTablet;